<template>
	<div v-html="svg" class="mysvg" :style="{ width: size+'px', height: size+'px', background: background ? background : '' }">
	</div>
</template>

<script setup lang="ts">
import type { GlyphIconName } from '@/stores/GlyphIcons.types'
import { ref, watch, onMounted } from 'vue'
import { useGlyphIconsStore } from '@/stores/GlyphIcons'

interface Props {
	icon: GlyphIconName
	size: string
	color?: string
	background?: string
}

const props = defineProps<Props>()
const svg = ref<string | undefined>(undefined)
const giStore = useGlyphIconsStore()

async function load() {
	if (props.icon) {
		svg.value = await giStore.getIcon(props.icon)
		if (svg.value) {
			svg.value = svg.value.replace('<svg', `<svg style="fill:${props.color ?? 'currentColor'};width:${props.size}px;height:${props.size}px" class="w-full h-full object-contain"`)
		}
	}
}

watch(() => props.icon, () => load())
watch(() => props.size, () => load())
watch(() => props.color, () => load())

onMounted(() => { load() })
</script>
